<template>
  <modal class="addbatchno-modal" title="新建批号" :accept="onAccept">
    <vx-form class="w-full" layout="v" label-align="top" ref="form">
      <form-item label="商品名称" label-align="none">{{product.name}}</form-item>
      <form-item required label="批号" >
        <vs-input class="w-full sm-3/4" placeholder="请输入批号" v-model="batchNo" />
      </form-item>
    </vx-form>
  </modal>
</template>
<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      batchNo: '',
    }
  },
  props: {
    onOk: Function,
    product: Object,
    batch: Object,
  },
  computed: {
    isNew() {
      return !this.batch
    }
  },
  mounted() {
    if (!this.isNew) {
      this.batchNo = this.batch.batchNo
    }
  },
  methods: {
    async onAccept() {
      console.log(this.$refs.form)
      await this.$refs.form.validate()
      if (this.isNew) {
        const data = {
          productID: this.product.id,
          batchNo: this.batchNo,
        }
        this.batch = await this.$s.product.createBatchNo(data)
        this.$notify({
          title: '成功新增商品批号',
        })
      } else {
        const data = {
          id: this.batch.id,
          batchNo: this.batchNo,
        }
        await this.$s.product.updateBatchNo(data)
        this.batch.batchNo = this.batchNo
        this.$notify({
          title: '成功修改商品批号',
        })
      }
      this.onOk({
        id: this.batch.id,
        batchNo: this.batchNo,
        productID: this.productID
      })
    }
  }

}
</script>
<style lang="scss">
.addbatchno-modal {
  .vs-dialog {
    max-width: 500px;
  }
}
</style>